var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4395 12.8722C7.8696 12.8723 9.2588 12.3951 10.387 11.5164L14.6436 15.7729C14.9615 16.08 15.4682 16.0712 15.7753 15.7532C16.0749 15.443 16.0749 14.9513 15.7753 14.6411L11.5188 10.3846C13.6994 7.57759 13.1916 3.53432 10.3846 1.35372C7.57756 -0.826884 3.53433 -0.319097 1.35372 2.48793C-0.826884 5.29496 -0.319097 9.33822 2.48793 11.5188C3.61801 12.3967 5.00846 12.873 6.4395 12.8722ZM3.01943 3.01697C4.9083 1.12806 7.97076 1.12803 9.85967 3.0169C11.7486 4.90577 11.7486 7.96823 9.85974 9.85714C7.97087 11.746 4.90841 11.7461 3.0195 9.85721C3.01947 9.85717 3.01947 9.85717 3.01943 9.85714C1.13056 7.98203 1.11943 4.93073 2.99454 3.04186C3.00282 3.03354 3.01111 3.02525 3.01943 3.01697Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon1);
export default __webpack_public_path__ + "static/media/SearchIcon1.5999057b9b98288c412c285adf73c7c7.svg";
export { ForwardRef as ReactComponent };